export default __webpack_public_path__ + "61f21fb.png";